import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-codesandbox"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0001 22L3.33984 17V7L12.0001 2L20.6604 7V17L12.0001 22Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M20.6604 12.0059L16.3398 14.5003V19.4948L20.6604 17.0003V12.0059Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M16.3302 4.5L12 2L7.66992 4.5L12 7L16.3302 4.5Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M7.66035 19.4947V14.5003L3.33984 12.0059V17.0003L7.66035 19.4947Z","fillRule":"evenodd","clipRule":"evenodd"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 12L20.6604 7M12.0001 12L12.0001 22M12.0001 12L3.33984 7M20.6604 7L12.0001 2L3.33984 7M20.6604 7V17L12.0001 22M12.0001 22L3.33984 17V7M20.6604 12.0059L16.3398 14.5003V19.4948L20.6604 17.0003V12.0059ZM12 2L16.3302 4.5L12 7L7.66992 4.5L12 2ZM3.33984 17.0003V12.0059L7.66035 14.5003V19.4947L3.33984 17.0003Z","strokeLinecap":"round","strokeWidth":"props.strokeWidth"}}]}]};

const LogoCodesandbox = Vue.extend<IconProps>({
  name: 'LogoCodesandboxIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-codesandbox',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoCodesandbox;
